import styled from "styled-components"

import { minWidth } from "utils"

import { citationStyles } from "../citations/styles"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem;
  padding-bottom: 6rem;
  font-size: 1.2rem;
  line-height: 1.67;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
  `}

  ${citationStyles}
`
